const SvgIconInfo = (props) => (
  <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1889_14441)">
      <path
        d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
        fill="#B0B0B0"
      />
    </g>
    <defs>
      <clipPath id="clip0_1889_14441">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgIconInfo;
